import NoiseType from "./NoiseType";

interface NoiseSelectionGroupProps {
  selectedType: NoiseType;
  onClickButton: (noiseType: NoiseType) => void;
}

const NoiseSelectionGroup = ({selectedType, onClickButton}: NoiseSelectionGroupProps) => {
  return (
    <div className="flex gap-2 bg-zinc-900 rounded-full p-1">
      {([NoiseType.White, NoiseType.Pink, NoiseType.Brown] as NoiseType[]).map(type => (
        <NoiseSelectionButton
          key={type}
          onClick={() => onClickButton(type)}
          isSelected={selectedType === type}
          noiseType={type}
        />
      ))}
    </div>
  );
};

interface NoiseSelectionButtonProps {
  isSelected: boolean
  noiseType: NoiseType
  onClick: () => void
}

const LABELS: Record<NoiseType, string> = {
  [NoiseType.White]: 'white',
  [NoiseType.Pink]: 'pink',
  [NoiseType.Brown]: 'brown',
};

const SELECTED_STYLES: Record<NoiseType, string> = {
  [NoiseType.White]: 'bg-zinc-100 text-zinc-900',
  [NoiseType.Pink]: 'bg-pink-200 text-pink-900',
  [NoiseType.Brown]: 'bg-amber-200 text-amber-900',
};

const NoiseSelectionButton = ({isSelected, noiseType, onClick}: NoiseSelectionButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`px-5 py-2 rounded-full text-sm font-medium transition-colors duration-150 ${
        isSelected
          ? SELECTED_STYLES[noiseType]
          : 'text-zinc-500 hover:text-zinc-200'
      }`}
    >
      {LABELS[noiseType]}
    </button>
  );
}

export default NoiseSelectionGroup;
